/* eslint-disable prefer-arrow-callback,no-var,comma-dangle */
(function Video() {
  /* @createVideoCloseButton
   * Create close button for video for when it gets sticky on tablet/desktop
   */
  var assetPrefix = document.querySelector("meta[name='asset-prefix']").getAttribute("content")


  function createVideoCloseButton(playerElement) {
    div = document.createElement('div');
    div.classList.add('tc_video__close');
    let button = document.createElement('button');
    let span = document.createElement('span');
    let text = document.createTextNode('Luk');
    span.appendChild(text);
    button.appendChild(span);
    button.setAttribute('aria-label', 'Luk video');
    button.addEventListener('click', function closeVideo() {
      playerElement.classList.add('tc_video__video--hide');
    });
    div.appendChild(button);
    playerElement.appendChild(div);
  }


  window.tv2 = window.tv2 || {};
  // Load the actual player script
  window.tv2.utils.loadScript(assetPrefix + 'player/player.3.0.93.js', function() {
    // Publish the video player to a tv2messages topic for consuming
    window.tv2messages.publish('tv2player.ready', setupVideoPlayer);
  })
  function setupVideoPlayer(videoElement, callback) {
    if (typeof callback !== 'function') {
      callback = function() {};
    }

    var id = videoElement.getAttribute('id');
    if (!id) {
      id = ['video', videoElement.getAttribute('data-guid'), new Date().getTime().toString(36)].join('-');
      videoElement.setAttribute('id', id);
    }

    // If the topic does not exist, that means we haven't even started to initate the player instance
    if (!window.tv2messages.getTopics()[id]) {
      // Call the tv2-player script function and create the actual player instance
      window.tv2player.create(videoElement).then(function _created(player) {
        // Publish the player instance to the topic, which will invoke the `callback` with the player instance
        window.tv2messages.publish(id, player);
      })
    }

    // Listen to when the player instance has been created, and invoke it with `callback`
    window.tv2messages.onceWithTimeout(id, 1e10, callback);
  }

  // when the dom is ready
  function domready() {
    window.tv2messages.onceWithTimeout('tv2player.ready', 1e10, function(setupVideoPlayer) {
      Array.prototype.slice
        .apply(window.document.querySelectorAll('.tc_video__video[data-guid]'))
        .forEach(function _video(playerElement) {
          setupVideoPlayer(playerElement);
          createVideoCloseButton(playerElement);
        });
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', domready);
  } else {
    domready();
  }
})();
